import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/sorting.svg";
var SortingOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  SortingOutline_default as default
};
